'use client';

var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
import MuscleFormTextInput from '../form-text-input';
import { useTranslations } from 'next-intl';
import EmailSquema from '@modules/shared/schemas/email-squema';
import useAfterInitEffect from '@lib/hooks/use-after-initialization-effect';
import InformativeCard from '../cards/informative';
import { cn } from '@lib/cn';
import useCssModules from '@lib/hooks/use-css-modules';
const EmailInput = _ref => {
  let {
    label,
    value,
    valueIsInvalid,
    invalidValueMessage,
    onChangeValue,
    setValueIsInvalid,
    fullLength,
    required,
    disabled,
    labelClassName = '',
    description,
    descriptionClassName,
    inputContainerClassName,
    containerClassName,
    includeSpecialCharactersInfoCard = false,
    reserveErrorSpace = false,
    dataTestId
  } = _ref;
  const t = useTranslations('Shared.TextInput');
  const {
    0: emailIsValid,
    1: setEmailIsValid
  } = useState((value !== null && value !== void 0 ? value : "").length > 0 ? EmailSquema.safeParse(value).success : true);
  const {
    0: invalidEmailMessage,
    1: setInvalidEmailMessage
  } = useState(invalidValueMessage);
  const {
    cssModules
  } = useCssModules();
  useAfterInitEffect(() => {
    const emailIsValid = EmailSquema.safeParse(value).success;
    setEmailIsValid(emailIsValid);
    setValueIsInvalid === null || setValueIsInvalid === void 0 || setValueIsInvalid(!emailIsValid);
    if (!emailIsValid) {
      setInvalidEmailMessage(t('INVALID_EMAIL'));
    }
  }, [value]);
  useEffect(() => {
    if (valueIsInvalid) {
      setInvalidEmailMessage(invalidValueMessage || t('INVALID_EMAIL'));
    }
  }, [valueIsInvalid, invalidValueMessage, t]);
  return __jsx("div", {
    className: cn('flex flex-col gap-2', containerClassName)
  }, __jsx(MuscleFormTextInput, {
    dataTestId: dataTestId,
    labelClassName: labelClassName,
    disabled: disabled,
    label: label || t('EMAIL'),
    value: value,
    placeholder: "email@email.com",
    valueIsInvalid: !emailIsValid || valueIsInvalid,
    onChangeValue: onChangeValue,
    invalidValueMessage: invalidEmailMessage,
    fullLength: fullLength,
    required: required,
    description: description,
    descriptionClassName: descriptionClassName,
    inputContainerClassName: inputContainerClassName,
    reserveErrorSpace: reserveErrorSpace
  }), includeSpecialCharactersInfoCard && __jsx(InformativeCard, {
    message: t('EMAIL_VALIDATION_MESSAGE')
  }));
};
export default EmailInput;